import React, { Component } from 'react';

class ReportMain extends Component {
	state = {  }
	render() { 
		return ( <h1>Report</h1> );
	}
}
 
export default ReportMain;